import React from "react";
import { PeregrineContextProvider as Peregrine, ToastContextProvider } from "@magento/peregrine";
import LocaleProvider from "./localeProvider";

/**
 * List of context providers that are required to run Venia
 *
 * @property {React.Component[]} contextProviders
 */
const contextProviders = [LocaleProvider, Peregrine, ToastContextProvider];
const ContextProvider = _ref => {
  let {
    children
  } = _ref;
  return contextProviders.reduceRight((memo, ContextProvider) => {
    return /*#__PURE__*/React.createElement(ContextProvider, null, memo);
  }, children);
};
export default ContextProvider;